import { cn } from "@/lib/utils";
import type { ToolRole } from "@/lib/api";

type BadgeKind = ToolRole | "org:admin";

interface RoleBadgeProps {
  role: BadgeKind;
  className?: string;
}

const STYLES: Record<BadgeKind, string> = {
  "tool-admin": "bg-blue-100 text-blue-700 border-blue-200",
  "tool-manager": "bg-teal-100 text-teal-700 border-teal-200",
  "tool-member": "bg-green-100 text-green-700 border-green-200",
  "tool-viewer": "bg-slate-100 text-slate-600 border-slate-200",
  denied: "bg-red-100 text-red-700 border-red-200",
  none: "bg-gray-100 text-gray-500 border-gray-200",
  "org:admin": "bg-purple-100 text-purple-700 border-purple-200",
};

const LABELS: Record<BadgeKind, string> = {
  "tool-admin": "tool-admin",
  "tool-manager": "tool-manager",
  "tool-member": "tool-member",
  "tool-viewer": "tool-viewer",
  denied: "denied",
  none: "No explicit role",
  "org:admin": "org:admin",
};

export function RoleBadge({ role, className }: RoleBadgeProps) {
  return (
    <span
      className={cn(
        "inline-flex items-center rounded-md border px-2 py-0.5 text-xs font-medium",
        STYLES[role],
        className
      )}
    >
      {LABELS[role]}
    </span>
  );
}
